import { OrmModel, StringField, AttrField } from 'vuex-orm-decorators'

import { modelNames } from '@/data/models/types'
import { ExternalIntegration, ExternalIntegrationProvider } from '@/data/models/domain/externalIntegrations'
import type { WooCommerceExternalIntegrationSettings } from '@/services/domain/externalIntegrations/types'

@OrmModel(modelNames.WOO_COMMERCE_EXTERNAL_INTEGRATION, modelNames.EXTERNAL_INTEGRATION)
export class WooCommerceExternalIntegration extends ExternalIntegration {
  @StringField(ExternalIntegrationProvider.WOO_COMMERCE)
  public provider: ExternalIntegrationProvider.WOO_COMMERCE

  @AttrField(null)
  public settings: WooCommerceExternalIntegrationSettings | null
}

export default WooCommerceExternalIntegration
